import React from 'react';
import environment from '../config/environment';

const EnvironmentIndicator: React.FC = () => {
  if (environment.isProduction) {
    return null; // Don't show indicator in production
  }

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: environment.isDevelopment ? '#ff6b6b' : '#feca57',
      color: 'white',
      padding: '8px 12px',
      borderRadius: '6px',
      fontSize: '12px',
      fontWeight: 'bold',
      zIndex: 9999,
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
    }}>
      {environment.environment.toUpperCase()}
    </div>
  );
};

export default EnvironmentIndicator;
